export default __webpack_public_path__ + "static/Group 2378-e2d5c2993e7f978dcf2164c04a9bdf63.png";